import type { PostApiV1RefundsRequest200AllOf } from './postApiV1RefundsRequest200AllOf';
import type { PostApiV1RefundsRequest200AllOfThree } from './postApiV1RefundsRequest200AllOfThree';

export type PostApiV1RefundsRequest200 = PostApiV1RefundsRequest200AllOf & PostApiV1RefundsRequest200AllOfThree;
